import Vue from "vue";

//用于多行文本省略
Vue.directive("ellipsis", {
    bind: function(el, binding, vnode, oldVnode) {
        const title = el.innerHTML.trim();
        if (typeof title !== "string") {
            throw new Error("v-ellipsis子元素只能为文本");
        }

        setTimeout(() => {
            const height = el.offsetHeight;

            let rTitle = "";
            for (let i = 0; i <= title.length; i++) {
                el.innerHTML = title.substr(0, i); // 动态设置项
                if (height < el.scrollHeight) {
                    el.style.overflow = "hidden";
                    rTitle = title.substr(0, i - 3) + "...";
                    break;
                }
            }
            if (rTitle) {
                // 如果有省略项 重新设置
                el.innerText = rTitle;
            }
        });
    },
});



// WEBPACK FOOTER //
// ./src/directives/ellipsis.js